import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { palettes, applyPaletteCSSVars, darkPalette } from '@/config/theme';
import type { ThemePalette } from '@/config/theme';

interface ThemeState {
  paletteKey: string;
  palette: ThemePalette;
  setPalette: (key: string) => void;
  /** Call once at app start to apply the persisted palette */
  hydrate: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      paletteKey: 'dark',
      palette: darkPalette,

      setPalette: (key: string) => {
        const p = palettes.find((pl) => pl.key === key) || darkPalette;
        applyPaletteCSSVars(p);
        set({ paletteKey: key, palette: p });
      },

      hydrate: () => {
        const { paletteKey } = get();
        const p = palettes.find((pl) => pl.key === paletteKey) || darkPalette;
        applyPaletteCSSVars(p);
        set({ palette: p });
      },
    }),
    {
      name: 'mymaintenances-theme',
      partialize: (state) => ({ paletteKey: state.paletteKey }),
    },
  ),
);
